'use client';

import Link from 'next/link';
import {useState, useContext} from 'react';

import CSS from './ProfileDropDown.module.scss';
import CSSUtility from '@/styles/utility.module.scss';
import Vector from '@/components/elements/vector/Vector';
import {UserDataContext} from '@/context/UserData';
import {resolveRoute} from '@/lib/routes';
import {formatCurrency} from '@/lib/utils';
import {Currency} from '@/types';
import {UserStarsAlias} from '@/types/api/users';

const urls = () =>
  [
    {
      title: resolveRoute('base.user.dashboard', undefined, true),
      url: resolveRoute('base.user.dashboard'),
      vectorName: 'RxDashboard'
    },
    {
      title: resolveRoute('base.user.security', undefined, true),
      url: resolveRoute('base.user.security'),
      vectorName: 'MdOutlineSecurity'
    },
    {
      title: resolveRoute('base.identity-verification', undefined, true),
      url: resolveRoute('base.identity-verification'),
      vectorName: 'FaUserCheck'
    }
  ] as const;

export default function ProfileDropDown({
  isOpen,
  isProcessing,
  isVerified,
  isPartiallyVerified,
  isPartiallyRejected
}: {
  isOpen: boolean;
  isProcessing: boolean;
  isVerified: boolean;
  isPartiallyVerified: boolean;
  isPartiallyRejected: boolean;
}) {
  const {userData, isAuthenticated, logout} = useContext(UserDataContext)!;
  const [isBalanceVisible, setIsBalanceVisible] = useState(false);

  const profile = userData?.profile;
  const identityVerificationUrl = resolveRoute('base.identity-verification');

  return isAuthenticated && profile ? (
    <section
      className={[
        CSS.profileDropDown,
        CSSUtility.scrollbar,
        isOpen ? CSS.open : ''
      ].join(' ')}>
      <div className={CSS.name}>{`${profile.firstName || ''} ${
        profile.lastName || ''
      }`}</div>
      <div className={CSS.level} data-level={profile.stars.star}>
        {Object.values(UserStarsAlias)[profile.stars.star]}
      </div>
      <div className={CSS.balance}>
        <div>
          <Vector name="PiPiggyBank" />
          <span>موجودی</span>
          <Vector
            name={isBalanceVisible ? 'FiEyeOff' : 'FiEye'}
            onClick={() => setIsBalanceVisible(state => !state)}
            hasFocus
          />
        </div>
        {isBalanceVisible && (
          <span>
            {formatCurrency(profile.balance || 0, Currency.IRT)} تومان
          </span>
        )}
      </div>
      <ul className={CSS.urls}>
        {urls().map((item, index) =>
          item.url === identityVerificationUrl ? (
            isVerified ? null : (
              <li
                key={index}
                className={
                  isProcessing
                    ? CSS.positive
                    : isPartiallyVerified && !isPartiallyRejected
                    ? CSS.special
                    : CSS.negative
                }>
                <Vector name={item.vectorName} />
                <Link href={item.url} className={CSS.url}>
                  {item.title}
                </Link>
                <Vector
                  svgProps={{size: '1.75rem'}}
                  name={isProcessing ? 'FaRegHourglassHalf' : 'FaExclamation'}
                />
              </li>
            )
          ) : (
            <li key={index}>
              <Vector name={item.vectorName} />
              <Link href={item.url} className={CSS.url}>
                {item.title}
              </Link>
            </li>
          )
        )}
      </ul>
      <div className={CSS.logout} onClick={logout}>
        <Vector name="BiExit" />
        خروج
      </div>
    </section>
  ) : null;
}
